import { Component } from "@angular/core";
import { Address } from "@app/address/model/address";
import { AddressUtilityService } from "@app/address/services/address.utility.service";

@Component({
    selector: "app-address-confirmation",
    templateUrl: "./address-confirmation.component.html",
    styleUrls: ["./address-confirmation.component.scss"],
})
export class AddressConfirmationComponent {
    address: Address;

    constructor(private readonly addrUtility: AddressUtilityService) {}
}
